var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD155"
    },
    d: "M256,512C114.842,512,0,397.159,0,256S114.842,0,256,0s256,114.842,256,256S397.159,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M256,0v512c141.158,0,256-114.842,256-256S397.159,0,256,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3E50"
    },
    d: "M256,436.33c-32.147,0-58.301-28.043-58.301-62.514c0-11.248,9.119-20.368,20.368-20.368 s20.368,9.119,20.368,20.368c0,12.009,7.88,21.778,17.566,21.778c9.685,0,17.565-9.77,17.565-21.778 c0-11.248,9.119-20.368,20.368-20.368c11.248,0,20.368,9.119,20.368,20.368C314.301,408.287,288.147,436.33,256,436.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3E50"
    },
    d: "M408.978,150.184c-14.392,0-294.371,0-305.955,0c-23.55,0-42.709,19.159-42.709,42.709v84.053 c0,23.55,19.159,42.709,42.709,42.709h100.859c23.55,0,42.709-19.159,42.709-42.709v-21.659h18.82v21.659 c0,23.55,19.159,42.709,42.709,42.709h100.859c23.55,0,42.709-19.159,42.709-42.709v-84.053 C451.686,169.343,432.528,150.184,408.978,150.184z M246.59,214.551v-21.659c0-0.663-0.02-1.318-0.05-1.974h18.92 c-0.03,0.654-0.05,1.312-0.05,1.974v21.659H246.59z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22313F"
    },
    d: "M408.978,150.184c-21.815,0-138.832,0-152.978,0v40.735h9.46c-0.03,0.654-0.05,1.312-0.05,1.974 v21.659H256v40.735h9.41v21.659c0,23.55,19.159,42.709,42.709,42.709h100.859c23.55,0,42.709-19.159,42.709-42.709v-84.053 C451.686,169.343,432.528,150.184,408.978,150.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#238CC5"
    },
    d: "M277.473,306.632c-7.453-8.425-6.664-21.298,1.761-28.75l131.64-116.44 c8.425-7.455,21.298-6.664,28.75,1.761c7.453,8.425,6.664,21.296-1.761,28.75l-131.64,116.44 C297.801,315.844,284.927,315.061,277.473,306.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51B3DA"
    },
    d: "M72.377,306.632c-7.453-8.425-6.664-21.298,1.761-28.75l131.64-116.44 c8.424-7.453,21.298-6.664,28.75,1.761c7.453,8.425,6.664,21.296-1.761,28.75l-131.64,116.44 C92.706,315.844,79.833,315.062,72.377,306.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22313F"
    },
    d: "M293.934,353.449c-11.248,0-20.368,9.119-20.368,20.368c0,12.009-7.88,21.778-17.565,21.778v40.735 c32.147,0,58.3-28.043,58.3-62.514C314.301,362.569,305.182,353.449,293.934,353.449z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolSvgrepoCom);
export default __webpack_public_path__ + "static/media/cool-svgrepo-com.78e2421054348c58b01a2a376f2ce7bc.svg";
export { ForwardRef as ReactComponent };